import { useState } from 'react';
import { TableInput } from '../../../../../components/common';
import TBodyRight from './TBodyRight';
import { Grid } from '@mui/material';
import {
  AddIconButton,
  DeleteIconButton,
  RemoveIconButton,
} from '../../../../../components/common/button/CustomIconButton';
import ModalCustom from '../../../../../components/common/Modal';
import PickPartAnnual from './PickPartAnnualPlan';
import AutocompleteMuiCustom from '../../../../../components/common/AutocompleteMuiCustom';
import TBodyLeftside from './TBodyLeftside';

interface IProps {
  moduleData: any;
  allmonth: any;
  partData: any;
  isView: boolean;
  handleDeleteRows: any;
}

const stickStylesColumn = {
  position: 'sticky',
  border: '1px solid black',
  zIndex: '1',
  backgroundColor: '#ffec99',
  // color: '#fff',
} as const;
const TBody = ({
  moduleData,
  isView,
  allmonth,
  handleDeleteRows,
  partData,
}: IProps) => {
  const [render, setRender] = useState(false);
  return (
    <tbody>
      {moduleData?.list?.map((item: any, index: number) => (
        <>
          <tr key={`${index}_table_row`}>
            <td
              rowSpan={2}
              style={{
                ...stickStylesColumn,
                left: 0,
                width: '50px',
                minWidth: '50px',
              }}
            >
              {index + 1}
            </td>

            <TBodyLeftside {...{ item, partData }} />

            <td>P</td>
            {/* always constant ⬇️*/}

            <TBodyRight
              item={item}
              isView={isView}
              index={index}
              allmonth={allmonth}
              setTBodyRender={setRender}
            />
            <td rowSpan={2}>
              <TableInput
                isView={isView}
                style={{ height: '80px' }}
                name="remarks"
                type="text"
                value={item.remarks}
                onChange={(e) => {
                  item.remarks = e.target.value;
                  setRender((prev) => !prev);
                }}
              />
            </td>
            <td rowSpan={2} style={{ minWidth: '100px', textAlign: 'center' }}>
              {!isView && (
                <DeleteIconButton
                  tooltipTitle={'delete'}
                  onClick={() => handleDeleteRows(index)}
                />
              )}
            </td>
          </tr>
          <tr>
            <th>A</th>
            {allmonth.map((month: any, mIdx: number) => (
              <td
                width="80px"
                height="45px"
                style={{
                  backgroundColor: item[month].doneDate && '#37b24d',
                  color: 'white',
                  textTransform: 'capitalize',
                  fontSize: '1.6rem',
                }}
              >
                {item[month].isTask && 'A'}
              </td>
            ))}
          </tr>
          {/* ---x---- */}
        </>
      ))}
    </tbody>
  );
};

export default TBody;
